// Phase 25 iter-9 — Galician (default).
// Mantemos un único namespace plano por simplicidade. Quitamos a clave
// cando o string aparece nun só sitio (a UI lóngrega traer "Cancelar"
// sempre dunha clave `common.cancel` ao traducila polo cal vai ben).

export const gl = {
  common: {
    cancel: 'Cancelar',
    save: 'Gardar',
    close: 'Pechar',
    loading: 'Cargando…',
    error: 'Erro',
    next: 'Continuar',
    back: 'Volver',
    submit: 'Enviar',
    retry: 'Reintentar',
  },
  language: {
    label: 'Idioma',
    gl: 'Galego',
    es: 'Castellano',
    pt: 'Português',
    en: 'English',
    unavailable: 'Próximamente',
  },
  header: {
    searchPlaceholder: 'Buscar animais por crotal, raza, concello…',
    searchShort: 'Buscar',
    sellCta: 'Vender un animal',
    menuAria: 'Menú de usuario',
    menu: {
      profile: 'Perfil e seguranza',
      purchases: 'As miñas compras',
      messages: 'Mensaxes',
      kyc: 'Verificación de identidade',
      roles: 'Os meus roles',
      shop: 'Tenda LeyroSpot',
      invoices: 'As miñas facturas',
      sell: 'Vender un animal',
      admin: 'Administración',
      logout: 'Saír',
      signin: 'Entrar',
      register: 'Crear conta',
    },
    notifications: {
      ariaLabel: 'Notificacións',
      title: 'Notificacións',
      emptyTitle: 'Aínda sen notificacións',
      emptyBody:
        'Cando recibas mensaxes, ofertas ou eventos das túas vendas e compras, aparecerán aquí.',
      markAllRead: 'Marcar todas',
    },
  },
  footer: {
    helpHeading: 'Axuda',
    helpCenter: 'Centro de axuda',
    safety: 'Seguridade da plataforma',
    contactHeading: 'Contacto',
    contactForm: 'Formulario de contacto',
    forFarmers: 'Para gandeiros',
    forBuyers: 'Para compradores',
    leyroSection: 'LeyroChain',
    sellAnimal: 'Vender un animal',
    traceability: 'Trazabilidade dixital',
    blockchain: 'Anclaxe blockchain',
    eudr: 'EUDR — cumprimento',
    catalog: 'Explorar animais',
    purchases: 'As miñas compras',
    auctions: 'Animais en subasta',
    plans: 'Plans e prezo',
    terms: 'Termos de uso',
    privacy: 'Política de privacidade',
    compliance: 'Cumprimento (EUDR · PEPA)',
    copyright: '© 2026 LeyroChain — Trazabilidade dixital do gando en Galicia.',
    privacyLink: 'Privacidade',
    termsLink: 'Termos',
    sitemap: 'Mapa do sitio',
  },
  cookieBanner: {
    text: 'Usamos só almacenamento esencial para que a plataforma funcione (sesión, idioma). Cero analytics, cero tracking.',
    accept: 'Entendido',
    more: 'Detalles',
    ariaLabel: 'Aviso de cookies',
  },
  marketplace: {
    badge: 'Trazabilidade certificada',
    title: 'Confianza no campo, animal a animal',
    subtitle:
      'Cada animal vén cun historial completo —vacinas, traslados, propietarios— ancorado en blockchain pública. Comprar ou vender, dende calquera lugar.',
    typeLabel: 'Tipo',
    provinceLabel: 'Provincia',
    types: {
      ALL: 'Todos',
      BEEF: 'Cárnica',
      DAIRY: 'Leiteira',
      BREEDING: 'Reprodución',
      AUCTION: 'Subasta',
    },
    provinces: {
      ALL: 'Toda Galicia',
      A_CORUNA: 'A Coruña',
      LUGO: 'Lugo',
      OURENSE: 'Ourense',
      PONTEVEDRA: 'Pontevedra',
    },
    categoryBar: {
      filters: 'Filtros',
      filtersWithCount: 'Filtros, {{count}} activo',
      filtersDialog: 'Filtros avanzados',
      scrollLeft: 'Desprazar á esquerda',
      scrollRight: 'Desprazar á dereita',
    },
    search: 'Buscar',
    salesCount: '{{count}} animais á venda',
    noResults: 'Ningún animal coincide cos filtros',
    noResultsHint: 'Proba con menos filtros ou volve nun rato.',
    sellCta: 'Vender un animal →',
    badges: { auction: 'Subasta', verified: 'Verificada' },
  },
  auth: {
    modal: {
      welcomeLogin: 'Benvido de novo',
      welcomeRegister: 'Crea a túa conta',
      tabLogin: 'Entrar',
      tabRegister: 'Crear conta',
      forgot: 'Esqueciches o contrasinal?',
      forgotCta: 'Recupera o acceso →',
      orSeparator: 'ou',
    },
    fields: {
      email: 'Email',
      name: 'Nome completo',
      password: 'Contrasinal',
      newPassword: 'Contrasinal (mín. 8 caracteres)',
      showPassword: 'Amosar contrasinal',
      hidePassword: 'Ocultar contrasinal',
    },
    login: { submit: 'Entrar', greet: 'Benvido, {{name}}' },
    register: {
      submit: 'Crear conta',
      next: 'Continuar',
      terms:
        'Acepto os <terms>Termos de uso</terms> e a <privacy>Política de Privacidade</privacy>.',
      titleRoles: 'Como vas usar LeyroChain?',
      subtitleRoles:
        'Marca un ou varios. Cada rol pode ter unha verificación específica (KYC). O primeiro que selecciones será o teu rol principal.',
      created: 'Conta creada',
      createdBody:
        'Enviamos un correo a {{email}} para que verifiques o teu enderezo. Comproba a bandexa de entrada e o spam.',
      createdNote:
        'Algunhas accións (vender un animal, asinar como veterinario, etc.) requirirán completar o KYC.',
      primaryBadge: 'Principal',
    },
    errors: {
      invalidEmail: 'Introduce un email válido.',
      passwordTooShort: 'Mínimo 8 caracteres.',
      passwordsMismatch: 'Os contrasinais non coinciden.',
      nameRequired: 'Introduce o teu nome.',
      termsRequired: 'Tes que aceptar os Termos e a Política de Privacidade.',
      captchaRequired: 'Pasa a verificación anti-bot.',
      rolesRequired: 'Marca polo menos un rol para continuar.',
      generic: 'Non se puido completar a operación.',
    },
  },
  billing: {
    title: 'Facturación',
    subtitle: 'O teu plan actual e xestión de pagamentos.',
    currentPlan: 'Plan actual',
    nextRenewal: 'Renóvase o {{date}}',
    free: 'Free',
    basic: 'Básico',
    pro: 'Pro',
    managePortal: 'Xestionar subscrición',
    portalDesc:
      'Cambia a túa tarxeta, ve facturas e cancela a subscrición dende o noso portal seguro de pagamentos.',
    seePlans: 'Ver plans dispoñibles →',
    notSubscribed: 'Aínda non tes subscrición activa. Bótalle un ollo aos plans.',
    invoiceNote: 'As facturas envíanse automaticamente ao teu email cando se procesan os cobros.',
  },
  shop: {
    title: 'Tenda LeyroSpot',
    subtitle:
      'Merca os kits de etiquetas NFC para marcar os teus animais e ligar cada un á cadea LeyroChain.',
    category: 'Tenda',
    price: 'Prezo',
    buy: 'Mercar',
    opening: 'Abrindo Stripe…',
    unavailable: 'Este SKU non está dispoñible neste momento.',
    ordersHeading: 'Os meus pedidos',
    trackingLabel: 'Seguimento',
    status: {
      PENDING_FULFILLMENT: 'Pendente de envío',
      SHIPPED: 'Enviado',
      DELIVERED: 'Entregado',
      CANCELLED: 'Cancelado',
    },
    errors: {
      load: 'Non se puido cargar a tenda. Téntao de novo nun momento.',
      checkout: 'Non se puido abrir o pagamento. Téntao de novo.',
    },
  },
  shopSuccess: {
    title: 'Pagamento recibido',
    body: 'Recibimos o teu pedido e xa está rexistrado na túa conta.',
    delivery:
      'Os kits envíanse por mensaxería 24-48h cando saen do almacén. Recibirás un email co número de seguimento.',
    viewOrders: 'Ver os meus pedidos',
  },
  shopCancel: {
    title: 'Pagamento cancelado',
    body: 'Pechaches o pagamento sen finalizar. Non se cobrou nada. Podes volver tentalo cando queiras.',
    retry: 'Volver á tenda',
  },
} as const;
